(function () {
    document.querySelector('.group-block__content.w-full.h-full.relative.flex.flex-col.md\:flex-row.justify-center.md\:justify-center.items-center.md\:items-center.flex-nowrap.spacing-style a.button.button--primary.button--sm.size-style:last-child').addEventListener('click', function (e) {
        e.preventDefault();

        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });

        this.blur();

        document.querySelector('.topbar__left-shipping.flex.items-center.gap-2')?.focus();
    });
})();